import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-investments-extract',
	templateUrl: './investments-extract.component.html',
	styleUrls: ['./investments-extract.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class InvestmentsExtractComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/investments/investments-extract/investments-extract.component.ts